<template>
  <div class="fullheight">
    <el-tabs @tab-click="handleClick" v-model="tabsVal">
      <el-tab-pane :label="item.label" :name="item.name" v-for="item in tabList" :key="item.index"></el-tab-pane>
    </el-tabs>
    <fe-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :style="{ height: maxHeight + 'px' }"
      :selection="true"
      :show-export="false"
      :quick-search-props="[
        { prop: 'f_demand_title', label: '标题' },
        { prop: 'f_tenant_name', label: '客户' },
        { prop: 'f_contacter', label: '联系人' }
      ]"
      ref="ecoTable"
    >
      <template v-slot:toolbar>
        <el-button size="small" type="primary" @click="showDialog()" v-if="!['2', '3', '4'].includes(tabsVal) && isShow">新增</el-button>
        <fe-delete-button
          class="marginLeft16"
          style="display: inline-block"
          :url="deleteUrl"
          :htTable="$refs.ecoTable"
          v-if="!['2', '3', '4'].includes(tabsVal) && isShow"
          @after-delete="afterDelete"
          >删除</fe-delete-button
        >
      </template>

      <template>
        <fe-table-column type="index" width="50" align="center" label="序号" />
        <fe-table-column prop="f_demand_no" label="建议编号" :sortable="true" :sort-by="'f_demand_no'" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="showDialog(scope.row.id, 'detail')">
              {{ scope.row.f_demand_no }}
            </el-link>
          </template>
        </fe-table-column>
        <fe-table-column prop="f_demand_title" label="标题" :sortable="true" :sort-by="'f_demand_title'" :show-overflow-tooltip="true"></fe-table-column>
        <fe-table-column prop="tenant_name" label="客户名称" :sortable="true" :sort-by="'f_tenant_name'" :show-overflow-tooltip="true"></fe-table-column>
        <fe-table-column prop="f_contacter" label="联系人" :sortable="true" :sort-by="'f_contacter'" :show-overflow-tooltip="true" />
        <fe-table-column prop="f_phone" label="联系电话" :sortable="true" :sort-by="'f_phone'" :show-overflow-tooltip="true" />
        <fe-table-column prop="f_status" label="状态" :sortable="true" :sort-by="'f_status'" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ handleStatus(scope.row.status) }}
          </template>
        </fe-table-column>
        <fe-table-column label="操作" width="140" v-if="isShow ? ['0', '1'].includes(tabsVal) : ['0', '1', '3'].includes(tabsVal)">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="showDialog(scope.row.id, 'edit')" v-if="scope.row.status === 1 && isShow">编辑</el-link>
            <div v-if="[1, 3].includes(scope.row.status)">
              <el-link
                type="primary"
                :underline="false"
                @click="showSwitchDialog(scope.row, 'review')"
                v-if="['0', '1'].includes(tabsVal) && !isShow && scope.row.status !== 3"
                >评审</el-link
              >
              <el-link
                type="primary"
                :underline="false"
                @click="showSwitchDialog(scope.row, 'online')"
                v-if="['0', '3'].includes(tabsVal) && !isShow && scope.row.status !== 1"
                >上线</el-link
              >
            </div>
          </template>
        </fe-table-column>
      </template>
    </fe-table>
    <!-- 新增需求反馈 -->
    <el-dialog
      class="hr-script-select"
      width="60%"
      title="优化建议"
      :visible.sync="dialogVisible"
      :before-close="clearableDialog"
      :close-on-click-modal="false"
      append-to-body
    >
      <div slot="title" class="dialog-header-title">
        <span class="name" style="font-weight: 600">优化建议</span>
      </div>
      <el-form :model="demandSubject" :rules="rules" ref="ruleForm" label-width="114px" class="demo-ruleForm">
        <div class="tips">
          <span style="color: red">提醒:</span>
          1、客户如有系统功能方面的优化建议，可以发起此流程！如需要操作方面的指导及系统报错，可直接联系小易客服，请不要发起此流程！
          2、优化建议并不构成我们对客户的产品开发承诺，是否优化以及什么时间完成优化，均由易筑进行综合评估后安排计划！
          3、新功能开发，线下联系营销或实施人员，进行需求调研后按规定流程进行任务安排，不走此流程。 特此说明！
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="建议编号:">
              <el-input v-model="demandSubject.demand_no" :disabled="true" placeholder="保存后自动生成" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="相关表单:" prop="form_name">
              <el-input v-model="demandSubject.form_name" @focus="focusInput"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="客户名称:">
              <el-input :disabled="true" v-model="demandSubject.tenant_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题:" prop="demand_title">
              <el-input clearable maxlength="200" v-model="demandSubject.demand_title"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="建议描述:" prop="demand_detail">
              <vue-ueditor-wrap :config="myConfig" v-model="demandSubject.demand_detail"></vue-ueditor-wrap>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人:" prop="contacter">
              <el-input clearable v-model="demandSubject.contacter" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话号码:" prop="phone">
              <el-input clearable type="number" v-model="demandSubject.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:">
              <el-input v-model="demandSubject.remarks" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件:" prop="attachment">
              <eip-attachment
                v-if="dialogVisible"
                v-model="demandSubject.attachment"
                model-name="demandSubject.attachment"
                :permission="'w'"
                propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
                accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
                limit="10"
                displayType="table"
                isInputEdit=""
                :configAttributes="{}"
                :multiple="true"
              >
                <span slot="labeldesc">附件</span>
              </eip-attachment>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="编制人:">
              <el-input disabled style="width: 80%" v-model="demandSubject.create_user"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编制时间:">
              <el-date-picker
                style="width: 80%"
                v-model="demandSubject.create_time"
                align="right"
                type="datetime"
                placeholder="选择日期"
                format="yyyy-MM-dd HH:mm:SS"
                disabled
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider v-if="!isHiden"></el-divider>
        <div v-if="!isHiden">
          <div v-if="demandSubject.demandAppraise && (demandSubject.demandAppraise.appraise_result == 1 || demandSubject.demandAppraise.appraise_result == 0)">
            <div class="dialog-header-title margin-div">
              <span class="name" style="font-weight: 600">易筑评审意见</span>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="评审意见:">
                  <span> {{ demandSubject.demandAppraise.appraise_opinion }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="评审结果:">
                  <span> {{ demandSubject.demandAppraise.appraise_result === 1 ? '评审通过' : '评审不通过' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="附件:">
                  <eip-attachment
                    v-model="demandSubject.demandAppraise.appraise_attachment"
                    model-name="demandSubject.demandAppraise.appraise_attachment"
                    :permission="'r'"
                    propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
                    accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
                    limit="10"
                    key="3"
                    displayType="table"
                    isInputEdit=""
                    :configAttributes="{}"
                    :multiple="true"
                  >
                    <span slot="labeldesc">附件</span>
                  </eip-attachment>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="demandSubject.demandOnline && demandSubject.demandOnline.online_date">
            <div class="dialog-header-title margin-div">
              <span class="name" style="font-weight: 600">开发完成情况</span>
            </div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="实际完成时间:">
                  <span> {{ demandSubject.demandOnline.online_date }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="说明:">
                  <span> {{ demandSubject.demandOnline.online_direction }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="附件:">
                  <eip-attachment
                    v-model="demandSubject.demandOnline.online_attachment"
                    model-name="demandSubject.demandOnline.online_attachment"
                    :permission="'r'"
                    propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
                    accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
                    limit="10"
                    key="2"
                    displayType="table"
                    isInputEdit=""
                    :configAttributes="{}"
                    :multiple="true"
                  >
                    <span slot="labeldesc">附件</span>
                  </eip-attachment>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="isHiden">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="clearableDialog">取消</el-button>
      </div>
    </el-dialog>
    <!-- 评审和上线 -->
    <el-dialog class="hr-script-select" width="50%" :title="title" :visible.sync="switchDialog" :close-on-click-modal="false" append-to-body destroy-on-close>
      <div slot="title" class="dialog-header-title">
        <span class="name" style="font-weight: 600">{{ title }}</span>
      </div>
      <el-form style="padding-top: 20px" :model="switchForm" :rules="switchRules" ref="switchRuleForm" label-width="114px" class="demo-ruleForm">
        <div v-if="title === '评审'">
          <el-form-item label="评审意见:">
            <el-input
              style="width: 80%"
              placeholder="请输入评审意见"
              type="textarea"
              maxlength="3000"
              v-model="switchForm.appraise_opinion"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="评审结果:" prop="appraise_result">
            <el-select placeholder="请选择评审结果" style="width: 80%" clearable v-model="switchForm.appraise_result">
              <el-option label="评审通过" value="1"></el-option>
              <el-option label="评审不通过" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="附件:" prop="appraise_attachment">
            <eip-attachment
              v-if="switchDialog"
              v-model="switchForm.appraise_attachment"
              model-name="switchForm.appraise_attachment"
              :permission="'w'"
              propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
              accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
              limit="10"
              key="4"
              displayType="table"
              isInputEdit=""
              :configAttributes="{}"
              :multiple="true"
            >
              <span slot="labeldesc">附件</span>
            </eip-attachment>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="实际完成时间:" prop="online_date">
            <el-date-picker
              v-model="switchForm.online_date"
              style="width: 80%"
              type="date"
              placeholder="请选择实际完成时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="说明:">
            <el-input style="width: 80%" type="textarea" maxlength="3000" placeholder="请输入说明" v-model="switchForm.online_direction" clearable></el-input>
          </el-form-item>
          <el-form-item label="附件:" prop="online_attachment">
            <eip-attachment
              v-if="switchDialog"
              v-model="switchForm.online_attachment"
              model-name="switchForm.online_attachment"
              :permission="'w'"
              propConf='[{"name":"prop1"},{"name":"prop2"},{"name":"prop3"},{"name":"prop4"},{"name":"prop5"},{"name":"prop6"}]'
              accept="jpg,jpeg,png,bmp,pdf,JPG,JPEG,PBG,BMP,PDF,doc,docx,xls,xlsx,ppt,pptx,rtf,txt,zip,rar,vsd,dwg,mp4,avi,3gp,rmvb,rm,wmv"
              limit="10"
              displayType="table"
              key="1"
              isInputEdit=""
              :configAttributes="{}"
              :multiple="true"
            >
              <span slot="labeldesc">附件</span>
            </eip-attachment>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSwitch">保存</el-button>
        <el-button @click="clearableSwitchDialog">取消</el-button>
      </div>
    </el-dialog>
    <EipFormDialog ref="eipFormDialog" :single="true" formType="pc" @onConfirm="dialogConfirm" appendToBody />
  </div>
</template>

<script>
import utils from '@/utils.js'
const EipFormDialog = () => import('@/components/dialog/EipFormDialog.vue')
let checkPhone = (rule, value, callback) => {
  let reg = /^1[345789]\d{9}$/
  if (!reg.test(value)) {
    callback(new Error('请输入正确手机号'))
  } else {
    callback()
  }
}
export default {
  components: {
    EipFormDialog
  },
  data() {
    return {
      maxHeight: document.body.clientHeight - 150,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      demandSubject: {
        demand_type: '1',
        form_name: ''
      },
      rules: {
        form_name: [{ required: true, message: '请选择表单' }],
        demand_title: [{ required: true, message: '请输入需求反馈标题' }],
        demand_detail: [{ required: true, message: '请输入需求描述' }],
        contacter: [{ required: true, message: '请输入联系人' }],
        phone: [
          { required: true, message: '请输入电话号码' },
          { validator: checkPhone, message: '请输入正确手机号' }
        ]
      },
      tabList: [
        {
          label: '全部',
          name: '0'
        },
        {
          label: '待评审',
          name: '1'
        },
        {
          label: '评审不通过',
          name: '2'
        },
        {
          label: '评审通过待开发',
          name: '3'
        },
        {
          label: '开发完成',
          name: '4'
        }
      ],
      switchForm: {},
      switchRules: {
        appraise_result: [{ required: true, message: '请选择需求评审结果' }],
        online_date: [{ required: true, message: '请选择实际完成时间' }]
      },
      tabsVal: '0',
      deleteUrl: '${business}/system/demand_feedback/',
      dialogVisible: false,
      myConfig: {
        initialFrameHeight: 240,
        UEDITOR_HOME_URL: '/ueditor/',
        // UEDITOR_HOME_URL: window.location.origin +'/'+ window.location.pathname.split('/')[1]+'/ueditor/',
        toolbars: [
          [
            'source',
            'undo', //撤销
            'bold', //加粗
            'indent', //首行缩进
            'italic', //斜体
            'underline', //下划线
            'strikethrough', //删除线
            'subscript', //下标
            'fontborder', //字符边框
            'superscript', //上标
            'formatmatch', //格式刷
            'fontfamily', //字体
            'fontsize', //字号
            'justifyleft', //居左对齐
            'justifycenter', //居中对齐
            'justifyright', //居右对齐
            'justifyjustify', //两端对齐
            'insertorderedlist', //有序列表
            'insertunorderedlist', //无序列表
            'lineheight', //行间距
            'forecolor', //字体颜色
            'simpleUpload'
          ]
        ],
        // 上传文件接口
        imageMaxSize: 2048000,
        imageAllowFiles: ['.png', '.jpg', '.jpeg'],
        imageFieldName: 'file',
        // 初始容器宽度
        initialFrameWidth: '100%',
        zIndex: 9001,
        enableAutoSave: false,
        readonly: false
      },
      method: true,
      isHiden: true,
      tenantId: '',
      isShow: true,
      switchDialog: false,
      title: '',
      refId: '',
      type: ''
    }
  },
  computed: {
    handleType() {
      return function (type) {
        const obj = {
          1: '优化建议',
          2: '新需求'
        }
        return obj[type]
      }
    },
    handleStatus() {
      return function (status) {
        const obj = {
          1: '待评审',
          2: '评审不通过',
          3: '待开发',
          4: '已完成'
        }
        return obj[status]
      }
    }
  },
  mounted() {
    this.tenantId = sessionStorage.getItem('tenantId')
    if (this.tenantId === '-1' || this.tenantId === '') {
      this.isShow = false
    } else {
      this.isShow = true
    }
  },
  methods: {
    focusInput() {
      this.$refs.eipFormDialog.showDialog()
    },
    dialogConfirm(data) {
      if (data && data.length > 0) {
        let payload = data[0]
        this.demandSubject.form_name = payload.name
        this.demandSubject.form_key = payload.formKey
      }
      this.$forceUpdate()
    },
    // 列表数据
    loadData(param, cb) {
      if (param && cb) {
        const obj = {
          param: param,
          cb: cb
        }
        sessionStorage.setItem('loadJSON', JSON.stringify(obj))
      }
      if (!param) {
        const session = JSON.parse(sessionStorage.getItem('loadJSON'))
        param = session.param
        cb = session.cb
      }
      if (!param.querys) {
        param.querys = []
      }
      if (this.tabsVal === '0') {
        if (!param.querys) {
          param.querys = []
        }
      } else {
        param.querys.push({
          group: 'advance',
          value: this.tabsVal,
          relation: 'OR',
          operation: 'LIKE',
          property: 'f_status'
        })
      }
      this.$http
        .post('${business}/system/demand_feedback/query', param)
        .then(
          (resp) => {
            let response = resp.data
            let res = response.rows
            res.forEach((item) => {
              item.f_id = item.id
              item.f_ref_id = item.ref_id
              item.f_demand_no = item.demand_no
              item.f_tenant_name = item.tenant_name
              item.f_demand_title = item.demand_title
              item.f_demand_detail = item.demand_detail
              item.f_contacter = item.contacter
              item.f_phone = item.phone
              item.f_remarks = item.remarks
              item.f_attachment = item.attachment
              item.f_create_user = item.create_user
              item.f_create_time = item.create_time
              item.f_form_data_rev = item.form_data_rev
              item.f_instance_id = item.instance_id
              item.f_tenant_id = item.tenant_id
              item.f_create_by = item.create_by
              item.f_create_org_id = item.create_org_id
              item.f_create_time = item.create_time
              item.f_update_by = item.update_by
              item.f_update_time = item.update_time
              item.f_create_by_name = item.create_by_name
              item.f_deleted = item.deleted
              item.f_data_status = item.data_status
              item.f_status = item.status
              console.log(item)
            })
            this.data = response.rows
            this.pageResult = {
              page: response.page,
              pageSize: response.pageSize,
              total: response.total
            }
          },
          (error) => {
            reject(error)
          }
        )
        .finally(() => cb())
    },
    // tab切换
    handleClick(tab) {
      this.tabsVal = tab.name
      this.$refs.ecoTable.tabChange2()
    },
    // 删除刷新数据
    afterDelete() {
      this.$refs.ecoTable.load()
    },
    showDialog(id, type) {
      type === 'edit' ? (this.isHiden = true) : type === 'detail' ? (this.isHiden = false) : (this.isHiden = true)
      if (!id) {
        this.demandSubject.create_user = this.$store.state.user.currentUserDetail.user.fullname
        this.demandSubject.create_time = utils.formatDate(new Date())
        this.demandSubject.tenant_name = sessionStorage.getItem('tenantName')
        this.method = true
      } else {
        this.method = false
        this.$nextTick(() => {
          this.$http.get('${business}/system/demand_feedback/' + id).then((res) => {
            if (res && res.data) {
              this.demandSubject = res.data
            }
          })
        })
      }

      this.dialogVisible = true
    },
    // 保存操作
    save() {
      if (this.demandSubject && this.demandSubject.attachment) {
        let attachmentFail = 0
        JSON.parse(this.demandSubject.attachment).map((item) => {
          if (item.status != 'success') {
            attachmentFail = attachmentFail + 1
          }
        })
        if (attachmentFail > 0) {
          this.$message.warning('请上传成功后再进行保存操作。')
          return
        }
      }
      this.demandSubject.demand_type = '1'
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.method) {
            this.$http.post('${business}/system/demand_feedback/', this.demandSubject).then((res) => {
              if (res && res.data.state) {
                this.$message.success('操作成功')
                this.clearableDialog()
              }
            })
          } else {
            this.$http.put('${business}/system/demand_feedback/', this.demandSubject).then((res) => {
              if (res && res.data.state) {
                this.$message.success('操作成功')
                this.clearableDialog()
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 关闭dialog 清空数据
    clearableDialog() {
      this.demandSubject = {}
      this.$refs['ruleForm'].resetFields()
      this.afterDelete()
      this.dialogVisible = false
    },
    clearableSwitchDialog() {
      this.switchDialog = false
      this.afterDelete()
    },
    showSwitchDialog(row, type) {
      this.refId = row.id
      type === 'review' ? (this.title = '评审') : (this.title = '上线')
      this.type = type
      this.switchDialog = true
      this.switchForm = {}
      if (this.$refs['switchRuleForm']) this.$refs['switchRuleForm'].resetFields()
    },
    saveSwitch() {
      this.switchForm.refId = this.refId
      this.$refs.switchRuleForm.validate((valid) => {
        if (valid) {
          if (this.type === 'review') {
            this.$http.post('${business}/system/demand_appraise/', this.switchForm).then((res) => {
              if (res && res.data.state) {
                this.$message.success('操作成功')
                this.clearableSwitchDialog()
              }
            })
          } else {
            this.$http.post('${business}/system/demand_online/', this.switchForm).then((res) => {
              if (res && res.data.state) {
                this.$message.success('操作成功')
                this.clearableSwitchDialog()
              }
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  margin-bottom: 30px;
  line-height: 30px;
  padding: 8px;
  border: 1px solid #d7dae2;
}
.margin-div {
  margin: 10px 0;
}
/deep/.el-textarea__inner {
  height: 200px !important;
}
/deep/ .el-dialog__body {
  padding: 0 20px !important;
}
</style>
